module.exports = __webpack_public_path__ + "img/x_xpower_icon.ef9f8bab.svg";